import { formatDisplayDate, formatTime } from '@/utils/date';
import type { FeedbackListItem } from '../types/feedback.types';

type FeedbackEntry = Pick<FeedbackListItem, 'feedbackDate' | 'enteredAt'>;

export function formatFeedbackEntryTime({ feedbackDate, enteredAt }: FeedbackEntry): string {
  const entryDate = formatDisplayDate(feedbackDate);
  if (enteredAt === null) return entryDate;
  return `${entryDate}, ${formatTime(enteredAt)}`;
}
